import login from './zh/Login'

export default {
  login,
  home: {
    'deviceState': '设备状态',
    'totalAuthorized': '总授权',
    'beAuthorized': '已授权',
    'onLine': '在线',
    'offLine': '离线',
    'taskState': '任务状态',
    'totalProgram': '节目总数 ',
    'approve': '审核通过 ',
    'reject': '审核不通过 ',
    'unreviewed': '未审核 ',
    'MaterialStatistics': '素材统计',
    'img': '图片',
    'video': '视频',
    'frequency': '音频',
    'doc': '文档',
    'systeminfo': '系统信息',
    'totalMemory': '总内存',
    'USED': '已使用',
    'residue': '剩余',
    'platform': '台',
    'individual': '个',
  },

  terminal: { //
    deviceState: '设备状态',
    deviceglTitle: '设备管理',
    DeviceProperties: '设备属性',
    device: {
      'MBFree': '剩余容量',
      'deviceState': '设备状态',
      'deviceName': '设备名称',
      'devicenumber': '设备编号',
      'deviceRAM': '设备内存',
      'deviceID': '设备ID',
      'deviceMAC': '设备MAC',
      'screenNumber': '屏幕数量',
      'deviceLshoocation': '设备定位',
      'AUTHORISE': '是否授权',
      'beAuthorized': '已授权',
      'unauthorized': '未授权',
      'resolution': '分辨率',
      'remarks': '备注',
      'deviceIP': '设备IP',
      'sysversion': '系统版本',
      'ViewTask': '查看任务',
      'offlineTime': '离线时长',
      'onofftime': '开关机时间',
      'uptime': '开机时间',
      'offTime': '关机时间',
      'Mon': '周一',
      'Tues': '周二',
      'Wednes': '周三',
      'Thurs': '周四',
      'Fri': '周五',
      'Satur': '周六',
      'a_key_phone': '一键报警电话',
      'sun': '周日',
      'operation': '操作',
      'type': '类型',
      'taskName': '任务名称',
      'dutyCycle': '任务周期',
      'startTime': '开始时间',
      'endTime': '结束时间',
      'dateline': '发送时间',
      'ClearExpired': '清除已过期',
      'starttime': '开始日期',
      'endtime': '结束日期',
      'sbjc': '设备检测',
      'sbjcz': '设备检测中',
      'successfully': '成功',
      'fairly': '失败',
      'serverIp': '服务器IP',
    },
    command: '远程指令',
    control: '远程监控',
    setting: '设置',
    upgradeTitle: '远程升级',
    upgrade: {
      'fileType': '类型',
      'fileName': '文件名',
      'versionNum': '软件版本号',
      'versionName': '软件包名',
      'sysversion': '系统版本号',
      'upTime': '上传时间',
      'serialName': '序号',
      'facilityID': '设备ID',
      'deviceName': '设备名称',
      'downSeed': '速度',
      'downprogress': '进度',
      'downState': '状态',
      'eliminate': '清除',
      'inquire': '查询',
      'Upgrademanagement': '升级管理',
      'UpgradeList': '升级列表',
      'Upgradeequipment': '升级设备',
      'speed': '速度',
      'progress': '进度',
      'remote': '远程监控',
      'Interface': '界面获取中',
      'preview': '双击预览图片',
      'interface': '监控界面'
    },
    StatisticsTitle: '展示统计',
    Statistics: {
      'fileName': '文件名',
      'preview': '预览',
      'type': '类型',
      'number': '次数',
      'statistical': '统计时长',
      'operation': '操作',
      'a': '台设备',
    },
    registrationTitle: '设备注册',
    registration: {
      'icon': '图标',
      'facilityID': '设备ID',
      'facilityIP': '设备IP',
    },
    instruct: {
      volume: '音量',
      restart: '重启',
      rouse: '唤醒',
      sleep: '休眠',
      shutdown: '关机',
      qlds: '清理定时',
      qlcp: '清理磁盘',
      qlrw: '清理任务',
      LoadingTitle: '指令下发',
      titlemini: '指令下发中',
      adjust: '调节音量',
    },
    flow: {
      flow: '流量',
      diagramName: '月流量图',
      chart: '时流量图',
      Daily: '日流量图',
      tip: '请点击柱状图查看详情',
    },
    deviceList: '设备列表',

  },

  program: {
    'company': '公司名称',
    'Screeningstate': '筛选状态',
    'verified': '审核通过',
    'refuse': '审核未通过',
    'unreviewed': '未审核',
    'unused': '未使用',
    'bytesUsed': '已使用',
    'qsrjmmc': '请输入节目名',
    'program': '节目',
    'programType': '节目类型',
    'tasks': '绑定任务数量',
    'resolution': '分辨率',
    'hdjm': '互动节目',
    'xxcb': '消息插播',
    'ptjm': '普通节目',
    'width': '宽度',
    'height': '高度',
    'task': '节目分组',
    'qxzwj': '请选择节目分类',
    'create': '立即创建',
    'addResolution': '添加分辨率',
    'programName': '节目名称',
    'auditstatus': '审核状态',
    'onstate': '使用状态',
    'guanlian': '已关联任务(个)',
    'pass': '通过',
    'refusea': '拒绝',
    'cjjm': '创建节目',
    'scenesetting': '场景设置',
    'sceneTime': '场景设置',
    'bgImg': '背景图片',
    'top': '上边距',
    'left': '左边距',
    'jmcj': '节目场景',
    'addbg': '添加背景图片',
    'selesc': '已选择素材个数',
    'adddecive': '添加设备',
    'selecteddevice': '已选设备',
    'review': '节目审核',
    'xgfz': '修改分组',
    'audit': '审核',
    'template': '模板列表',
    'move': '移动',
    'delcontrol': '删除控件',
    'full': '全屏展示',
    'addsucai': '添加素材',
    'sticky': '置顶',
    'Bottom': '置底',
    'ascend': '上一层',
    'descend': '下一层',
    'DaemonTime': '守护进程时间',
    'VideoDisplayType': '视频显示类型',
    'ImageDisplayType': '图片显示类型',
    'DualConfiguration': '双屏异显配置',
    'FullStretch': '全屏拉伸',
    'GeometricScaling': '等比缩放',
    'FullDisplay': '原尺寸显示',
    'reverse': '界面反向',
    'MandatoryAdaptation': '强制适配',
    'Software': '软件重启生效',
    'qbccj': '请保存场景',
    'addImage': '添加图片',
    'addMixture': '添加混播',
    'addVideo': '添加视频',
    'addAudio': '添加音频',
    'addDoc': '添加文档',
    'default_effect': '默认效果',
    'right_to_left': '右到左',
    'left_to_right': '左到右',
    'top_to_bottom': '上到下',
    'bottom_to_top': '下到上',
    'accordion_squeeze': '手风琴挤压',
    'zoom_in_gradient': '放大渐变',
    'zoom_out_gradient': '缩小渐变',
    'rotate_in': '3D旋转进',
    'rotate_out': '3D旋转出',
    'field_gradient': '景深渐变',
    'Left_right_rotation': '左右旋转',
    'up_and_down_rotation': '上下旋转',
    'counter_clockwise_rotation': '逆时针旋转',
    'clockwise_rotation': '顺时针旋转',
    'zoom_up_and_down': '上下缩放',
    'frame_effect': '3D画框效果',
    'scale_gradient': '缩放渐变',
    'zoom_in_on': '放大消隐动画',
    'transparent_gradient': '透明渐变',
    'gradient_scaling': '渐变缩放',
    'upper_left_corner': '左上角',
    'center_top': '顶部居中',
    'upper_right_corner': '右上角',
    'center_left': '左对齐居中',
    'center': '居中',
    'center_right': '右对齐居中',
    'lower_left_corner': '左下角',
    'bottom_center': '底部居中',
    'lower_right_corner': '右下角',
    'copy': '复制',
    'ckhz': '长宽互置',
    'display': '显示类型',
    'screen': '屏幕类型',
    'proportion': '比例',
    'refresh_time': '刷新时间',
    'count_down': '倒计时',
    'is_timing': '正计时',
    'timing': '计时类型',
  },

  task: {
    'createTask': '创建任务',
    'tasktype': '任务类型',
    'bindingProgram': '绑定节目',
    'releaseTask': '发布任务',
    'addTask': '添加任务',
    'TaskName': '任务名称',
    'Playmode': '播放模式',
    'ReplaceMode': '替换模式',
    'Spotpatterns': '插播模式',
    'simulcastingmode': '同步模式',
    'AppendMode': '追加模式',
    'TaskGroup': '任务分组',
    'Broadcast': '播放周期',
    'Continue': '持续播放',
    'broadcasting': '定时播放',
    'newlyTask': '新增任务',
    'management': '任务管理',
    'DownloadList': '下载列表',
    'timehorizon': '时间范围',
    'information': '节目信息',
    'playback': '播放周期',
    'Completed': '已完成',
    'unfinished': '未完成',
    'ptrw': '普通任务',
    'sprw': '双屏任务',
    'pmlx': '屏幕类别',
    'zmcb': '字幕插播',
    'jmfbl': '节目分辨率',
    'total': '全部',
    'cycle': '有效周期',
    'daterange': '日期范围',
    'Editingtasks': '编辑任务',
    'ptlx': '普通类型',
    'splx': '双屏类型',
    'hdlx': '互动类型',
    'size': '任务大小',
    'interactive': '互动任务',
    'addprogram': '添加节目',
    'equipment': '查看设备',
    'deletask': '删除任务',
    'taskimprom': '任务导出',
    'downloadsu': '下载成功',
    'downloading': '正在下载',
    'Waiting_download': '等待下载',
    'task_list': '任务列表',
    'selectDate': '任务周期',
  },

  system: {
    'serverSettings': '服务器设置',
    'thresholdSettings': '设置内存阀值',
    'maxspeed': '最大下载速度',
    'maxnumber': '最大下载台数',
    'Memory': '内存清理级别',
    'ncql': '内存清理级别',
    'yldh': '预留报警电话',
    'configuration': '为了保证服务器运行流畅请查看一下配置信息',
    'unit': '单位',
    'Reserved': '预留报警电话',
    'maxmin': '最大下载台数建议小于',
    'custom': '请随意设置',
    'management': '角色管理',
    'phoneNumber': '手机号',
    'nickName': '昵称',
    'creationTime': '创建时间',
    'operation': '操作',
    'log': '日志管理',
    'Module': '模块名',
    'action': '行为',
    'operationType': '操作类型',
    'newUsers': '新增用户',
    'contact': '联系方式',
    'Review': '审核权限',
    'confirmPassword': '确认密码',
    'dualIp': '操作IP',
    'userName': '用户名',
    'time': '时间',
    'qxzkssj': '请选择开始时间',
    'qxzjs': '请选择结束时间',
    'qxzmode': '请选择模块名',
    'runningLog': '运行日志',
    'operationLog': '操作日志',
    'logPS': '提示：导出服务器运行错误日志',
    'sysHelp': '系统帮助',
    'Formatspecification': '格式说明',
    'fileFormat': '文件格式',
    'imgFormat': '图片格式',
    'audioFormat': '音频格式',
    'videoFormat': '视频格式',
    'softwareVersion': '软件版本',
    'backup': '数据备份',
    'instructions': '使用说明',
    'derivePS': '请在版本更新前点击导出按钮进行数据库备份',
    'versionsPS': '在更新版本后重新进入发布系统的此页面，点击导入按钮选择上面导出按钮导出的文件',
    'basicSetting': '基础设置',
    'iscompress': '上传是否压缩',
    'isstatistics': '是否开启统计',
    'fileSize': '上传大小限制',
    'bjdhkg': '报警电话',
    'yes': '是',
    'no': '否',
    'wbgs': '文本格式',
    'maximum': '最大值',
    'Uploadconfiguration': '基础设置',
    'broadband': '宽带',
    'addrole': '新增角色',
    'updated': '更新日期',
    'details': '更新细节',
    'customset': '自定义设置',
    'Wallpaper': '壁纸上传',
    'landscape': '横屏',
    'PorTrait': '竖屏',
    'xgsbyh': '转移设备',
    'default': '清除壁纸',
    'logout': '终端退出密码',
    'ps': '请输入用户登录账号',
    'port': '端口号',
    'ad': '当前任务 (黄色图标为替换模式,橙色图标为追加模式,红色图标为插播模式，蓝色图标为同步模式,粉色图标为计划模式)',
    'exsetsing': 'U盘注册',
    'upan': 'U盘操作',
    'qjyl': '区间音量',
    'tzyl': '调整音量',
    'assist': '此操作请找售后协助',
    role_email:'邮箱',
    login_email:'请输入邮箱',
  },

  management: {
    'open_authorization': '授权平台账号开通',
    'open_call': '报警通话',
    'dredge': '开通',
    'essential': '基本信息',
    'CustomerName': '客户姓名',
    'Authorization': '授权台数',
    'capacity': '空间容量',
    'userState': '用户状态',
    'address': '客户地址',
    'Account': '账户期限',
    'servercapacity': '服务器容量',
    'Addcustomer': '添加客户',
    'phone': '客户账号',
    'Pass': '密码',
    'ConfirmPass': '确认密码',
    'name': '姓名/公司名',
    'adder': '地址',
    'effective': '有效日期',
    'serverPix': '服务器容量只能是100的整数倍数',
    'Customer': '客户账户',
    'onlineNum': '离线台数',
    'offLineNum': '在线台数',
    'Customeraddress': '客户地址',
    'deleclient': '删除客户',
    'distribution': '分配设备',
    'xgkyrl': '修改可用容量',
    'sqsbts': '授权设备台数',
    'gross': '总量',
    'used': '已用',
    'Editrole': '修改角色',
    'rejection': '驳回理由',
    'qdql': '轻度清理(删除节目信息)',
    'zdql': '中度清理(删除内存中所有的大型媒体文件)',
    'gdql': '高度清理(格式化SD卡)',
    'exerrlog': '导出错误日志',
    'exdelog': '导出日志',
    'download_speed': '下载限速',
    'serverrate': '下载速度不得大于',
    'editcustomer': '编辑客户',
    'addcustomer': '添加客户',
    'abcd': '请输入用户名/手机号',
    'activation': '激活',
    'recharge': '充值',
    'description': '订单描述',
    'number': '订单编号',
    'amount': '订单金额',
    'status': '订单状态',
    'charge': '剩余话费',
    'wzf': '未支付',
    'yzf': '已支付',
    'credit': '充值金额',
    'dollar': '元',
    'payable': '应付金额',
    'pay': '支付',
    'gratuitous': '无赠送',
    'f30': '送30元',
    'f10': '送10元',
    'export_code': '导出授权码',
    'expiration_time': '过期时间',
    'ps': '此激活码当天有效，不能重复使用',
    'export_file': '导入文件',
    'average_flow': '平均流量',
    'cus_phone':'手机号',
    email:'邮箱',
    cus_email:'客户邮箱',


  },
  getCode: '获取验证码',
  'usercenter': '用户中心',
  'LogOff': '注销登陆',
  'account': '账号',
  'editpassword': '修改密码',
  'edituser': '修改用户',
  'phone': '手机',

  'uspix': '账号只能是字母、数字、字母数字的组合',
  'oldPass': '旧密码',
  'newPass': '新密码',
  'ConfirmPass': '确认密码',
  'package': '安装包',
  'WordDOC': 'Word文档',
  'videoDetails': '视频详情',
  'Material': '素材管理',
  'Program': '节目管理',
  'Task': '任务管理',
  'Settings': '系统配置',
  'Terminal': '终端管理',
  'Manage': '客户管理',
  'immediately': '立即修改',
  'lang': '中',
  'zh': '中文',
  'en': '英文',
  'version': '版本号',
  'customer': '修改客户',
  'download': '下载',
  'watching': '在线观看',
  'download_again': '重新下载',
  'select_device': '选择设备',
  'prev': '上一页',
  'next': '下一页',
  'day': '天',
  'tsfm': '天时分秒',
  'month': '月份',

  material: {
    name: '素材名称',
    materialType: '素材类型',
    state: '状态',
    fileSize: '文件大小',
    scupload: '素材上传',
    zzscdsl: '正在上传的数量',
    updata: '上传',
    abortUpdata: '终止上传',
    upfairly: '上传失败',
    uploaded: '上传完毕',
    Boundmaterial: '已绑定素材',
    Boundpo: '已绑定节目',
    upch: '上传成功',
    'material_group': '素材分组',
  },

  btns: {
    'confirm': '确定',
    'newgroup': '新建分组',
    'cancel': '取消',
    'submit': '提交',
    'creation': '创建',
    'export': '导出',
    'importing': '导入',
    'delete': '删除',
    'rename': '重命名',
    'alldelete': '批量删除',
    'send': '发送',
    'mainScreen': '主屏',
    'viceScreen': '副屏',
    'preview': '预览',
    'add': '添加',
    'save': '保存',
    'removeAll': '清除全部',
    'clearaway': '清除',
    'clearCompleted': '清除已完成',
    'remove': '一键清除',
    'refresh': '刷新',
    'search': '搜索',
    'upgradeEquipment': '升级设备',
    'Editversion': '编辑版本号',
    'inquire': '查询',
    'examine': '查看',
    'examineuser': '查看用户',
    'Retrieve': '检索设备',
    'AKregister': '一键注册',
    'edit': '编辑',
    'reset': '重置',
    'all': '全选',
    'EmptyCanvas': '清空画布',
    'movegrouping': '移动分组',
    'uploadFiles': '上传文件',
    'newProgram': '新建节目',
    'Akeytoempty': '一键清空',
    'addrole': '增加角色',
    'enabled': '启用',
    'disable': '停用',
    'clickupload': '点击上传',
    'next': '下一步',
    'back': '上一步',
    'amend': '修改',
    'addroles': '添加角色',
    'addprogram': '添加节目',
    'close': '关闭',
    'updata': '上传',
    'open': '开启',
    'Traffic_statistics': '流量统计',
    'Broadcast_statistics': '播放统计',
    paste:"粘贴",
  },

  communal: {
    placeholder: '请输入内容',
    zwsj: '暂无数据',
    name: '名称',
    describe: '描述',

  },

  tip: {
    tip: '提示',
    warmprompt: '温馨提示：此功能只能在局域网下使用，公网用户请勿使用此功能！',
    a: '开关机时间间隔必须大于五分钟',
    b: '最大下载台数建议小于70台',
    b1: '最大下载台数建议小于150台',
    b2: '最大下载台数建议小于200台',
    c: '最大下载速度建议小于200kb',
    c1: '最大下载速度建议小于500kb',
    c2: '最大下载速度建议小于1000kb',
    c3: '最大下载速度建议小于2000kb',
    c4: '最大下载速度建议小于5000kb',
    d: '文档上传使用说明',
    e: '请在版本更新前点击导出按钮进行数据库备份',
    f: '在更新版本后重新进入发布系统的此页面，点击导入按钮选择上面导出按钮导出的文件',
    g: '提示：导出服务器运行错误日志',
    h: '(服务器修改定位，设备端不同步，请知悉)',
    j: '图片会按照 < 1920 > 像素进行压缩',
    k: '关闭此功能则不统计节目的次数和时间',
    z: '请输入大于30的数字',
    cczjsc: '将永久删除该数据, 是否继续?',
    qddc: '确定导出？',
    successfully: '保存成功',
    tjcg: '添加成功',
    xgcg: '修改成功',
    fscg: '发送成功',
    sccg: '删除成功',
    i: '将删除未绑定节目的素材',
    o: '是否导出',
    l: '节目删除(此节目已绑定以下任务，确定将永久删除节目和任务!)',
    m: '确定清理定时开关机',
    n: '已取消',
    p: '确定删除？',
    q: '确定修改？',
    deletefailed: '删除失败',
    editch: '编辑成功',
    editsb: '编辑失败',
    xzwj: '请选择升级文件',
    ygwj: '只能选择一个文件',
    imgv: '请输入img文件正确的系统版本号',
    iimgv: '请输入img文件的系统版本号',
    zipv: '请输入zip文件的系统版本号',
    sjsb: '确定升级设备',
    znsck: '只能删除空文件夹',
    sybz: '剩余空间不足',
    aa: '任务名称字数必须在2到50之间',
    bb: '任务结束日期不能小于开始日期',
    cc: '任务结束时间不能小于开始时间',
    dd: '任务结束时间不能等于开始时间',
    ee: '任务结束时间不能小于当前时间',
    ff: '任务周期不能为空',
    gg: '请选择要绑定节目',
    hh: '请给屏幕一添加节目',
    jj: '请给屏幕二添加节目',
    beh: '版本号只能为纯数字',
    oned: '只能勾选一台设备',
    srpz: '请输入手机号码或者账号',
    gecw: '用户名格式不正确',
    wurew: '当前没有任务',
    qdqc: '确定清除, 是否继续?',
    qddefbl: '是否删除该分辨率',
    qddesce: '是否删除场景?',
    ll: '文件名称重复，是否替换重复文件?',
    qq: '确定修改当前状态?',
    ww: '导出etv-ip.txt放在U盘根目录，插上设备，可修改服务器信息',
    xx: 'ps:清除当前日期之前所有的未使用的素材和任务',
    sjbn: '时间不能小于3S',
    ztxyzg: '字体需要足够的间距',
    nameim: '姓名/公司名不能为空',
    seletTime: '请选择有效日期',
    sqts: '授权台数必须大于0',
    cgsyts: '超过剩余台数',
    bnxy: '不能小于已授权台数',
    bnxyrl: '不能小于已使用容量',
    cgsy: '超过剩余容量',
    frqrl: '服务器容量输入过大',
    selekkh: '请选择要删除的客户',
    delekh: '只能删除下一级的客户',
    tip_copy:"复制成功",
  },

  msg: {
    qxzsb: '请选择设备',
    qxzsc: '请选择素材',
    phoneisenu: '电话号码不能为空',
  },

  common: {
    'state': '状态',
    'cmmfz': '重命名分组',
    'cmmsb': '重命名设备',
    'keyword': '关键字',
  },

  placeholder: {
    qsrfzmc: '请输入分组名称',
    qsrszz: '请输入数字值',
    bzq: '电话号码格式不正确,请输入11位电话号码',
    qqrwz: '请输入网址',
    qsrjmm: '请输入旧密码',
    qsrsbid: '请输入设备ID',
    qsrgjz: '请输入关键字',
    qsrheight: '请输入正确的高度',
    qsrwidth: '请输入正确的宽度',
    qsrbs: '请输入100的整数倍数',
    qsrz: '请输入-1~999999之间的值',
    qsraddr: '请输入地址',
    qsrbm: '请输入包名',
    qsrbh: '请输入设备编号',
    qsrmm: '请输入8位的包含数字、字母、特殊字符的密码',
    lcmmbyz: '两次输入的密码不一致',
    qxzcer: '请选择开始日期',
    qxzend: '请选择结束日期',
    qxztime: '请选择结束时间',
    qxzendtime: '请选择开始时间',
    a: '输入的容量不能小于已用容量',
    b: '输入值过大',
    qxzrwfz: '请选择任务分组',
    qxz: '请选择',
    qxzjmfl: '请选择节目分类',
    qxzjm: '请选择节目',
    qxzrw: '请选择任务',
    qxzfbl: '请选择分辨率',
    qxzhdqy: '请选择活动区域',
    qxzwzsj: '请选择完整的时间段',
    qxzysc: '请选择要删除的文件',
    qxzfile: '请选择文件',
  },
  codekey: {
    err: '验证码错误',
  },
  nav: {
    image: '图片',
    video: '视频',
    audio: '音频',
    mixture: '混播',
    date: '日期',
    weeks: '星期',
    countDown: '倒计时',
    time: '时间',
    weather: '天气',
    subtitle: '字幕',
    webPage: '网页',
    doc: '文档',
    streaming: '流媒体',
    button: '按钮',
    area: '区域',
    hdmin: 'hdmin'
  },
  settimg: {
    'fontColor': '文字颜色',
    'bgColor': '背景颜色',
    'fontSize': '文字大小',
    'direction': '滚动方向',
    'speed': '滚动速度',
    'city': '选择城市',
    'effect': '切换效果',
    'uniformly': '统一设置切换时间',
    'time': '间隔',
    'text': '字幕内容',
    'aligning': '对齐方式',
    'nodes': '时间节点',
    'unit': '单位',
    'DXVA': '硬件加速',
    'isopen': '是否开启',
    'address': '添加地址',
    'btnFont': '按钮文字',
    'interact': '互动',
    'still': '静止',
    'ms': '慢速',
    'zs': '中速',
    'ks': '快速',
    'bt': '自下向上',
    'lr': '自左向右',
    'rl': '自右向左',
    'dwxs': '单位显示',
    'font': '字体',
    'unity': '统一设置音量',
    'no_trigger': '无触发',
    'scene_jump': '场景跳转',
    'website': '第三方网站 ',
    'preview': '全屏预览 ',
    'APK': '第三方APK ',
    'select': '选择场景',
    'addweb': '添加网站',
    'addpacket': '添加APK包',
    'volume': '视频音量',
    'Switching': '切换时间',
    'back': '触摸返回',
    'noback': '不返回',
    'return': '返回',
    'stretch': '图片、视频会被拉伸',
  },
  edit_pass: {
    "account_center": "账号安全中心",
    "password_management": "密码管理",
    "enter_password": "输入新密码",
    "ps1": "当前密码过于简单，为保护您的账户安全，请尽快修改密码",
    "please_new_password": "请输入您要设置的新密码",
    "submit": "提交",
    "ps": "请输入8位数带有字母、数字和包含'~@#$%^&+=!()*'的英文特殊符号的密码",
    "ps2": "当前密码长时间未更新，为保护您的账户安全，请尽快修改密码",
  },
  append_field:{
    allDayText: '全天',
    weekPlan: '周计划',
    dayPlan: '天计划',
    addProgramPlan: '添加节目计划',
    selectProgram: '请选择节目',
    selectTaskCycle: '请选择任务周期',
    selectPlanTimeRange: '请选择计划时间范围',
    editProgramPlan: '编辑节目计划',
    startTimeError: '开始时间不能晚于或等于结束时间',
    maxProgramPlans: '每天最多仅能创建17条节目计划',
    noCoexistTasks: '计划设置仅能选择周计划或者天计划创建',
    overlappingPlans: '计划或者计划时间重叠，无法创建计划',
    closePlan: '关闭计划',
    enablePlan: '启用计划',
    planIsEmpty: '计划设置为空',
    login_background: '登录背景',
    login_carousel: '轮播图',
    logo: '图标设置',
    title: '标题',
    tip_swiper_list: '列表最多可上传6张轮播图，请重新选择',
    tip_size: '推荐上传尺寸：867*611',
    tip_del_logo: '不能删除默认图',
    default_mode: '默认模式',
    default_mode_description: '设置为默认模式后，设备连接上服务器将自动下发此节目',
    apk_version: '(APK版本7.0.0.7以上有效)',
    plan_settings: '计划设置',
    plan_mode: '计划模式',
    edit_plan_settings: '编辑计划设置',
    add_program_info: '请添加节目信息',
    reset_plan: '重置计划',
    confirm_reset_plan: '是否重置当前计划',

  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh.js